import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { isSuperAdmin, isAdmin, isStaff, isAgent, isStudent } from '../../utils/roleUtils'

export default function ProtectedRoute({ children, requiredRole }) {
  const { isAuthenticated, user } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (requiredRole) {
    if (requiredRole === 'SUPER_ADMIN' && !isSuperAdmin(user)) {
      return <Navigate to="/" replace />
    }
    if (requiredRole === 'ADMIN' && !isAdmin(user)) {
      return <Navigate to="/pending-approval" replace />
    }
    if (requiredRole === 'STAFF' && !isStaff(user)) {
      return <Navigate to="/pending-approval" replace />
    }
    if (requiredRole === 'AGENT_OR_STAFF' && !isStaff(user) && !isAgent(user)) {
      return <Navigate to="/pending-approval" replace />
    }
    if (requiredRole === 'USER' && !isStudent(user)) {
      return <Navigate to="/dashboard" replace />
    }
  }

  return children
}
